import { render, staticRenderFns } from "./FormatTextbox.vue?vue&type=template&id=ca64287a&"
import script from "./FormatTextbox.vue?vue&type=script&lang=js&"
export * from "./FormatTextbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports